import React from 'react';
import PublicPageLayout from 'components/layouts/PublicPageLayout';
import { selectDynamicBlockContent } from 'modules/frontend/slice';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import ACTIONS from 'modules/rootActions';
import { useEffectOnce } from 'react-use';

const TermsAndConditionsPage = () => {
  const dispatch = useAppDispatch();
  const dynamicContent = useAppSelector(selectDynamicBlockContent);

  useEffectOnce(() => {
    dispatch({
      type: ACTIONS.FETCH_DYNAMIC_BLOCK_CONTENT,
      payload: {
        keys: ['terms-and-conditions'],
      },
    });
  });
  return (
    <PublicPageLayout>
      <section className="m-auto flex w-[80%] flex-col py-[24px] text-sm sm:w-[650px] sm:text-base">
        <h2 className="mb-10 text-center text-[24px] font-bold md:text-4xl leading-[1.2]">
          Your Flexicar Membership Terms
        </h2>
        {dynamicContent &&
          dynamicContent.value.map((content, index) => {
            return (
              <div
                key={`c-${index}`}
                className="dynamic-content-container-public flex flex-col gap-y-[20px] text-[14px] md:text-[18px]"
                dangerouslySetInnerHTML={{
                  __html: content.description,
                }}
              />
            );
          })}
      </section>
    </PublicPageLayout>
  );
};

export default TermsAndConditionsPage;
